import ProgressAnalysisEyeReport from "../../../ProgressionAnalysisReport/ProgressAnaysisEyeReport";

export default function FetchExam({ selectedExam }) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      <ProgressAnalysisEyeReport
        key={selectedExam.id}
        examReport={selectedExam.reportData}
        examData={selectedExam}
      />
    </div>
  );
}
